module.exports = __webpack_public_path__ + "static/hoopp-logo-b8e9ce5983f0efa375662c774ccd7b03.png";